import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/works',
      name: 'works',
      component: () => import('./views/Works.vue')
    },
    {
      path: '/works/dronertc',
      name: 'dronertc',
      component: () => import('./views/DroneRTC.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (from.name == 'home') {
    if (to.name == 'about' || to.name == 'works' || to.name == 'dronertc') {
      document.getElementsByTagName('body')[0].style.backgroundImage = 'none';
    }
  }
  if (to.name == 'home') document.getElementsByTagName('body')[0].style.backgroundImage = 'url(https://i.imgur.com/3eDr6nP.png)';
  next();
});

export default router